// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen,
  Building
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sponsors: UserTick,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  company: Building,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const homeScreen: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="Grox Home Screen Settings" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [
    {
      id: 'homeScreen',
      title: <FormattedMessage id="HomeScreen" />,
      type: 'collapse',
      icon: icons.company,
      children: [
        {
          id: 'home-components-list',
          title: <FormattedMessage id="Home Components List" />,
          type: 'item',
          url: '/apps/homeScreen/home-components-list',
          breadcrumbs: false
        },
        {
          id: 'AddHomeScreenComponent',
          title: <FormattedMessage id="Add Home Component" />,
          type: 'item',
          url: '/apps/homeScreen/AddHomeScreenComponent'
        },
          {
          id: 'homeScreen-images-list',
          title: <FormattedMessage id="HomeScreen Image List" />,
          type: 'item',
          url: '/apps/homeScreen/homeScreen-images-list',
          breadcrumbs: false
        },
        {
          id: 'AddHomeScreenImage',
          title: <FormattedMessage id="Add App HomeScreen Image" />,
          type: 'item',
          url: '/apps/homeScreen/AddHomeScreenImage'
        },
        {
          id: 'home-components-itemList',
          title: <FormattedMessage id="Home Component Items List" />,
          type: 'item',
          url: '/apps/homeScreen/home-components-itemList',
          breadcrumbs: false
        },
        {
          id: 'AddNewHomeComponentItem',
          title: <FormattedMessage id="Add Home Component Item" />,
          type: 'item',
          url: '/apps/homeScreen/AddNewHomeComponentItem'
        },
        // {
        //   id: 'home-components-config',
        //   title: <FormattedMessage id="Home Component Items List" />,
        //   type: 'item',
        //   url: '/apps/homeScreen/home-components-config',
        //   breadcrumbs: false
        // },
        {
          id: 'AddComponentToLayout',
          title: <FormattedMessage id="Assign Component To Layout" />,
          type: 'item',
          url: '/apps/homeScreen/AddComponentToLayout'
        },
       
      ]
    },
    {
      id: 'flavor',
      title: <FormattedMessage id="Flavors" />,
      type: 'collapse',
      icon: icons.company,
      children: [
        {
          id: 'flavor-components-list',
          title: <FormattedMessage id="Flavor Components List" />,
          type: 'item',
          url: '/apps/flavor/flavor-components-list',
          breadcrumbs: false
        },
        {
          id: 'AddFlavorScreenComponent',
          title: <FormattedMessage id="Add Flavor Component" />,
          type: 'item',
          url: '/apps/flavor/AddFlavorScreenComponent'
        },
        //   {
        //   id: 'flavorScreen-images-list',
        //   title: <FormattedMessage id="Flavor Screen Image List" />,
        //   type: 'item',
        //   url: '/apps/flavor/flavorScreen-images-list',
        //   breadcrumbs: false
        // },
        // {
        //   id: 'AddHomeScreenImage',
        //   title: <FormattedMessage id="Add App HomeScreen Image" />,
        //   type: 'item',
        //   url: '/apps/homeScreen/AddHomeScreenImage'
        // },
        {
          id: 'flavor-components-itemList',
          title: <FormattedMessage id="Flavor Component Items List" />,
          type: 'item',
          url: '/apps/flavor/flavor-components-itemList',
          breadcrumbs: false
        },
        {
          id: 'AddNewFlavorComponentItem',
          title: <FormattedMessage id="Add Flavor Component Item" />,
          type: 'item',
          url: '/apps/flavor/AddNewFlavorComponentItem'
        },
        // {
        //   id: 'home-components-config',
        //   title: <FormattedMessage id="Home Component Items List" />,
        //   type: 'item',
        //   url: '/apps/homeScreen/home-components-config',
        //   breadcrumbs: false
        // },
        {
          id: 'AddFlavorComponentToLayout',
          title: <FormattedMessage id="Assign Component To Layout" />,
          type: 'item',
          url: '/apps/flavor/AddFlavorComponentToLayout'
        },
       
      ]
    },
   
    
  ]
};

export default homeScreen;
